<template>
  <footer class="footer">
    <div class="columns is-centered is-vcentered footerColumns">
      <div class="column is-4 left">
                  <p class="footer-title">Associated Partners</p>
        <div class="partner-wrapper">
          <img class="partner-logo" :src="require('@/assets/partners/jd.png')" />
          <img class="partner-logo" :src="require('@/assets/partners/anytime.png')" />
          <img class="partner-logo" :src="require('@/assets/partners/quick_grip.jpg')" />
        </div>
        <router-link class="footer-title" to="/register">Own a Gym?</router-link>
        <div class="is-flex">
          <router-link class="footer-link mr-1" to="/register">Sign up</router-link>
          <a class="footer-link mr-1" :href="dashboard_link" target="_blank">Sign in</a>
        </div>
      </div>
      <div class="column is-4 has-text-centered">
        <div class="flex-column">
          <router-link class="navbar-item" to="/">
            <img
              :src="require('@/assets/images/PNG/MyGymChecker-Logo-PNG-WhiteBlue.png')"
              class="navbar-logo m-a"
            />
          </router-link>
          <div class="t-and-c-container">
            <a
              class="t-and-c"
              href="/Legal/Terms-And-Conditions.pdf"
              target="_blank"
            >Terms and Conditions</a>
            <a class="t-and-c" href="/Legal/Privacy-Policy.pdf" target="_blank">Privacy Policy</a>
          </div>
        </div>
      </div>
      <div class="column is-4 right">
        <Social v-for="(media, index) in socials" :key="index" :media="media" />
      </div>
    </div>
  </footer>
</template>

<script>
import Social from "@/components/atoms/Social.vue";
export default {
  components: {
    Social
  },
  data() {
    return {
      dashboard_link: process.env.VUE_APP_BASE_DASHBOARD_URL,
      socials: [
        {
          icon: "fab fa-youtube",
          link: "https://www.youtube.com/channel/UCMyG9qoEh2Yz3KLnCciZN-A",
          color: "#FF0000"
        },
        {
          icon: "fab fa-facebook",
          link: "https://www.facebook.com/mygymchecker/",
          color: "#1877F2"
        },
        {
          icon: "fab fa-linkedin",
          link: "https://www.linkedin.com/company/my-gym-checker",
          color: " #007BB5"
        },
        {
          icon: "fab fa-twitter",
          link: "https://twitter.com/Mygymchecker",
          color: "#1DA1F2"
        },
        {
          icon: "fab fa-instagram",
          link: "https://instagram.com/mygymchecker?r=nametag",
          color: "#C32AA3"
        },
        {
          icon: "fas fa-user-circle",
          link: process.env.VUE_APP_BASE_DASHBOARD_URL,
          color: "#00c5fd"
        }
      ]
    };
  }
};
</script>

<style scoped>
.right {
  text-align: right;
}

.left {
  text-align: left;
}

@media (max-width: 768px) {
  .column {
    text-align: center !important;
  }
}

.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-title {
  margin-bottom: 0.5rem;
}

.mr-1 {
  margin-right: 1rem;
}

.mobileListRegister {
  float: left;
  margin-left: 4rem;
}

.mobileListLogin {
  float: right;
  margin-right: 4rem;
}

.partner-logo {
  width: 10rem;
  margin: 1rem 0.5rem 1rem 0;
}

.partner-wrapper {
  margin: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.footer {
  overflow: hidden;
}

.footer-title, .footer-link {
  color: white;
  font-weight: 600;
}

.footerColumns {
  max-width: 90vw;
  margin: auto;
}

.is-flex {
  align-items: flex-start;
  justify-content: flex-start;
}



.t-and-c {
  padding: 0.25rem;
  color: #b8b8b8;
}

@media (max-width: 768px) {
  .t-and-c-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .is-flex {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  
  .partner-wrapper {
    align-items: center;
    justify-content: center;
  }
}

.t-and-c:hover {
  color: #00c5fd;
}

.navbar-item:hover {
  background-color: transparent;
}
</style>